module.exports = __webpack_public_path__ + "static/media/screenshot_history_1_en.c329c884.png";